export default {
  title: 'Taxas',
  subtitle: 'Substituição da taxa de serviço por restaurante para {{company}}.',
  card_title: 'Taxa de serviço',
  banner: {
    default_summary: 'Padrão do parceiro: {{percentage}}% · mín {{min}} · máx {{max}}.',
    override_hint: 'Substitua abaixo para definir uma taxa diferente para este restaurante.',
    suggested_summary: 'Valores iniciais sugeridos: {{percentage}}% · mín. {{min}} · máx. {{max}}.',
    suggested_hint: 'Ajuste-os abaixo e guarde para cobrar uma taxa de serviço neste restaurante.',
    own_fee_hint: 'Este restaurante cobra a sua própria taxa, definida abaixo.',
    saved_summary: 'Os seus últimos valores guardados: {{percentage}}% · mín. {{min}} · máx. {{max}}.',
    saved_hint:
      'A taxa de serviço está desativada. Guarde estes valores, ou altere-os primeiro, para a voltar a ativar.',
  },
  form: {
    recommended: 'Recomendado: {{value}}',
    percentage: {
      label: 'Percentagem da taxa de serviço',
      tooltip: 'Percentagem do valor da encomenda cobrada ao cliente como taxa de serviço.',
    },
    min_amount: {
      label: 'Valor mínimo da taxa de serviço',
      tooltip: 'As taxas calculadas abaixo deste valor são arredondadas para cima até este.',
    },
    max_amount: {
      label: 'Valor máximo da taxa de serviço',
      tooltip: 'A taxa de serviço nunca excede este valor, independentemente do valor da encomenda.',
    },
  },
  limits:
    'Deve manter-se dentro dos limites da FoodAmigos: máx {{max_percentage}}% / {{max_amount}}, mínimo pelo menos {{min_amount}}.',
  not_charged_notice:
    'Neste momento, não é cobrada nenhuma taxa de serviço neste restaurante. Guarde uma taxa abaixo para a ativar.',
  zero_percentage_warning:
    'Uma percentagem de 0% não desativa a taxa de serviço: as taxas calculadas abaixo do valor mínimo são arredondadas para cima, pelo que cada encomenda é sempre cobrada pelo menos com o mínimo.',
  buttons: {
    edit: 'Editar',
    cancel: 'Cancelar',
    save: 'Guardar',
    reset_to_default: 'Repor padrão do parceiro',
    turn_off: 'Desativar taxa de serviço',
  },
  toasts: {
    load_error: 'Não foi possível carregar as definições da taxa de serviço.',
    failed_to_save_changes: 'Falha ao guardar alterações',
    changes_got_saved: 'Alterações guardadas',
    reset_to_default: 'Substituição removida — aplica-se o padrão do parceiro.',
    reset_to_default_skipped: 'Substituição removida — nenhuma taxa de serviço é cobrada até que guarde uma.',
    turned_off: 'Taxa de serviço desativada. Os seus valores são mantidos para quando a voltar a ativar.',
  },
};
